import { Routes } from '@angular/router';
import { Unauthenticated } from 'src/app/core/pages/unauthenticated/unauthenticated';
import { Unauthorised } from 'src/app/core/pages/unauthorised/unauthorised';
import { ErrorLayoutComponent } from 'src/app/core/layouts/error-layout/error-layout';
import { authenticatedRedirectGuard, authorisedRedirectGuard } from 'src/app/core/guards/auth-redirect.guard';

export const UnauthenticatedPath = 'unauthenticated';
export const UnauthorisedPath = 'unauthorised';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'prefix',
    component: ErrorLayoutComponent,
    children: [{
      path: UnauthenticatedPath,
      pathMatch: 'full',
      component: Unauthenticated,
      canActivate: [authenticatedRedirectGuard],
    },
    {
      path: UnauthorisedPath,
      pathMatch: 'full',
      component: Unauthorised,
      canActivate: [authorisedRedirectGuard],
    }]
  }
];
